define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/table/AggregateFrom",
	"csi/xml"
], function(array,declare,AggregateFrom,xml) {

	return declare(AggregateFrom, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set default name for ProductAlternative on form - not popup PA spec table
			this.inherited(arguments);

			var	urlSpec = view.getFixedValue ? view.getFixedValue("PASpec") : null;
			if (urlSpec) {
				view.addDefaultValue(xml.ATTR_NAME, view.cacheView.getNode(urlSpec).$Name);
			}
		}
	});
});